import { Paper, Text, Stack, Badge, Group } from "@mantine/core";
import { BuilderQuestionGroup } from "@/types/interview.types";

interface ReviewStepProps {
  companyName: string;
  groups: BuilderQuestionGroup[];
  openingStatement?: string;
  closingStatement?: string;
}

export function ReviewStep({
  companyName,
  groups,
  openingStatement,
  closingStatement,
}: ReviewStepProps) {
  return (
    <Stack gap="md">
      <Paper p="md" radius="md" withBorder>
        <Text fw={600} mb="xs">
          Company
        </Text>
        <Text>{companyName}</Text>
      </Paper>

      {openingStatement && (
        <Paper p="md" radius="md" withBorder>
          <Text fw={600} mb="xs">
            Opening Statement
          </Text>
          <Text c="dimmed" style={{ whiteSpace: "pre-wrap" }}>
            {openingStatement}
          </Text>
        </Paper>
      )}

      {closingStatement && (
        <Paper p="md" radius="md" withBorder>
          <Text fw={600} mb="xs">
            Closing Statement
          </Text>
          <Text c="dimmed" style={{ whiteSpace: "pre-wrap" }}>
            {closingStatement}
          </Text>
        </Paper>
      )}

      {groups.map((group) => (
        <Paper
          key={group.id}
          className="review-group-section"
          p="md"
          radius="md"
        >
          <Text fw={600} size="lg" mb="md">
            {group.name}
          </Text>

          {group.questions.length === 0 ? (
            <Paper className="review-warning" p="sm" radius="sm">
              <Text c="red" size="sm">
                No questions in this group
              </Text>
            </Paper>
          ) : (
            <Stack gap="sm" className="review-questions-list">
              {group.questions.map((question) => (
                <Paper
                  key={question.id}
                  className="review-question-item"
                  p="sm"
                  radius="sm"
                  withBorder
                >
                  <Group
                    justify="space-between"
                    wrap="nowrap"
                    align="flex-start"
                  >
                    <Text className="review-question-text" style={{ flex: 1 }}>
                      {question.text || "(No question text)"}
                    </Text>
                    <Group gap="xs">
                      <Badge
                        className="review-question-type"
                        variant="filled"
                        color="violet"
                        size="sm"
                      >
                        {question.type === "open-ended"
                          ? "Open-ended"
                          : "Number scale"}
                      </Badge>
                      <Badge
                        variant="light"
                        color={question.maxFollowups === 0 ? "gray" : "blue"}
                        size="sm"
                      >
                        {question.maxFollowups === 0
                          ? "No follow-ups"
                          : `Max ${question.maxFollowups} follow-up${question.maxFollowups === 1 ? "" : "s"}`}
                      </Badge>
                    </Group>
                  </Group>
                </Paper>
              ))}
            </Stack>
          )}
        </Paper>
      ))}
    </Stack>
  );
}
